const CARRY_OVER_PROPERTY_PREFIX = '_atc_';

export const pickCarryOverLineItemProperties = (
  properties?: Record<string, string>,
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(properties ?? {}).filter(([key]) => key.startsWith(CARRY_OVER_PROPERTY_PREFIX)),
  );

export const getLineIdentity = (
  variantId: number,
  properties?: Record<string, string | null | undefined> | null,
): string =>
  JSON.stringify([
    variantId,
    Object.entries(properties ?? {})
      .filter(([, value]) => value !== null && value !== undefined && value !== '')
      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB)),
  ]);
